export enum Step {
  // Keep all enums to avoid breaking references, but we're only using the old ones
  DISCUSSION_TOPICS = 'DISCUSSION_TOPICS',
  ABOUT_COMPANY = 'ABOUT_COMPANY',
  BUSINESS_LOCATION = 'BUSINESS_LOCATION',
  ABOUT_YOU = 'ABOUT_YOU',
  ABOUT_EMPLOYEES = 'ABOUT_EMPLOYEES',
  SELECT_FIRST_ACTION = 'SELECT_FIRST_ACTION',
  SCHEDULE_CALL = 'SCHEDULE_CALL',
  REQUEST_DETAILS = 'REQUEST_DETAILS',

  // New - keeping but not using
  ASSESSMENT = 'ASSESSMENT',
  OWNER_CHECK = 'OWNER_CHECK',
  ADD_PIN = 'ADD_PIN',
  ADD_OWNER = 'ADD_OWNER',
  ACKNOWLEDGE_1 = 'ACKNOWLEDGE_1',
  ACKNOWLEDGE_2 = 'ACKNOWLEDGE_2',
  ACKNOWLEDGE_3 = 'ACKNOWLEDGE_3',
  ACKNOWLEDGE_4 = 'ACKNOWLEDGE_4',
  ACKNOWLEDGE_5 = 'ACKNOWLEDGE_5',
  HANDS_FREE = 'HANDS_FREE',
  ACTIVATE_1 = 'ACTIVATE_1',
  ACTIVATE_2 = 'ACTIVATE_2',
  ACTIVATE_3 = 'ACTIVATE_3',
  ACTIVATE_4 = 'ACTIVATE_4',
  ACTIVATE_5 = 'ACTIVATE_5',
  ACTIVATE_6 = 'ACTIVATE_6',
  SET_UP_1 = 'SET_UP_1',
  SET_UP_2 = 'SET_UP_2',
  SET_UP_3 = 'SET_UP_3',
  SET_UP_4 = 'SET_UP_4',
  SET_UP_EMPLOYEES = 'SET_UP_EMPLOYEES',
  ADD_DOCUMENTS = 'ADD_DOCUMENTS',
  PERMISSIONS = 'PERMISSIONS',
  CASE_MANAGEMENT = 'CASE_MANAGEMENT',
  TRANSITION_TO_SETUP = 'TRANSITION_TO_SETUP',
  TRANSITION_TO_EMPLOYEE = 'TRANSITION_TO_EMPLOYEE',
  TRANSITION_TO_FILES = 'TRANSITION_TO_FILES',
  SET_UP_MANAGERS = 'SET_UP_MANAGERS',
  SET_UP_EXECUTIVES = 'SET_UP_EXECUTIVES',
  SET_UP_OVERSIGHT = 'SET_UP_OVERSIGHT',
  SUMMARY = 'SUMMARY',
}

// We're keeping ParentStep but we won't actively use it
export enum ParentStep {
  ASSESSMENT = 'Assessment',
  ACKNOWLEDGE = 'Acknowledge',
  SET_UP = 'Set Up',
  ACTIVATE = 'Activate',
  ADD_ON = 'Add On',
}

export const journeys = {
  ER: {
    LITE: [
      Step.DISCUSSION_TOPICS,
      Step.ABOUT_COMPANY,
      Step.BUSINESS_LOCATION,
      Step.ABOUT_EMPLOYEES,
    ],
    DEDICATED: [
      Step.DISCUSSION_TOPICS,
      Step.ABOUT_COMPANY,
      Step.BUSINESS_LOCATION,
      Step.ABOUT_YOU,
      Step.ABOUT_EMPLOYEES,
      Step.SELECT_FIRST_ACTION,
      Step.SCHEDULE_CALL,
      Step.REQUEST_DETAILS,
    ],
    // Keep ELITE journey for compatibility, but we're not using it
    ELITE: [
      Step.DISCUSSION_TOPICS,
      Step.ABOUT_COMPANY,
      Step.BUSINESS_LOCATION,
      Step.ABOUT_YOU,
      Step.ABOUT_EMPLOYEES,
      Step.SELECT_FIRST_ACTION,
      Step.SCHEDULE_CALL,
      Step.REQUEST_DETAILS,
    ],
  },
  EE: {},
};

export const pathDefaults = {
  [Step.DISCUSSION_TOPICS]: {
    slug: 'discussion-topics',
    id: Step.DISCUSSION_TOPICS,
    label: 'Discussion Topics',
    progressOrder: 1,
    hideBack: true,
  },
  [Step.ABOUT_COMPANY]: {
    slug: 'about-company',
    id: Step.ABOUT_COMPANY,
    label: 'About Company',
    progressOrder: 2,
  },
  [Step.BUSINESS_LOCATION]: {
    slug: 'business-location',
    id: Step.BUSINESS_LOCATION,
    label: 'Business Location',
    progressOrder: 3,
  },
  [Step.ABOUT_YOU]: {
    slug: 'about-you',
    id: Step.ABOUT_YOU,
    label: 'About You',
    progressOrder: 4,
  },
  [Step.ABOUT_EMPLOYEES]: {
    slug: 'about-employees',
    id: Step.ABOUT_EMPLOYEES,
    label: 'About Employees',
    progressOrder: 5,
  },
  [Step.SELECT_FIRST_ACTION]: {
    slug: 'select-first-action',
    id: Step.SELECT_FIRST_ACTION,
    label: 'Select First Action',
    progressOrder: 6,
  },
  [Step.SCHEDULE_CALL]: {
    slug: 'schedule-call',
    id: Step.SCHEDULE_CALL,
    label: 'Schedule Call',
    progressOrder: 7,
  },
};
